<template>
  <v-container fluid>
    <h1>Siding</h1>
    <v-row>
      <v-col cols="12" xl="8" lg="8" md="8" sm="12">
        <v-row>
          <v-img :src="image" class="image" alt="Siding Image" left></v-img>
        </v-row>
        <v-row>
          <p>
            If you’re tired of scraping and painting wood siding every few
            years, or if you just need an updated look for your home’s current
            exterior, siding replacement is another of AquaDuct’s specialties.
            We can help you save time and maintenance expenses by choosing a
            siding material that complements your home and lifestyle.
          </p>
        </v-row>
        <v-row :class="theme + '-alt-background-1'">
          <h2>We Use VSI Certified Installers</h2>
          <p>
            AquaDuct is the <linkto text="Colorado Springs" to="/location/coloradosprings"></linkto> 
            siding company with years of
            experience installing quality siding materials on homes throughout
            the Front Range. We understand that our customers want the most
            skilled technicians working on their siding project, which is why
            Scott, the owner became a Certified Installer through the Vinyl
            Siding Institute (VSI). This certification offers you the following
            benefits:
          </p>
          <ul>
            <li>Independent validation of our skills and knowledge.</li>
            <li>Higher quality work requiring fewer callbacks.</li>
            <li>
              VSI Certified Installers must renew their certificatiosn every
              three years through ongoing education.
            </li>
          </ul>
          <p>
            Your home deserves the best. Be sure the quality of your
            installation is as good as the products you’re installing by
            choosing AquaDuct, a VSI Certified Installer.
          </p>
        </v-row>
        <h2>Visualize Your Dreams with Mastic</h2>
        <p>
          AquaDuct proudly offers siding products from Mastic Home Exteriors, a
          brand with a long history of quality and innovation. Mastic began
          offering home exterior solutions in 1932, followed by the breakthrough
          invention of vinyl siding in 1959. Today, one of every four home
          exteriors remodeled with vinyl siding uses Mastic siding!
        </p>
        <p>
          Not sure what you want your home to look like? AquaDuct can give your
          home exterior a complete virtual makeover with Mastic’s Dreamhome
          Visualizer. We photograph your home, and then using computer imagery,
          we apply siding, shutters, trim and colors to help you explore the
          possibilities for an exterior remodel. You can even save and share
          your favorites.
        </p>
        <h2>Get a Quote for Expert Colorado Springs Siding Installation</h2>
        <p>
          If you’re ready for an exciting new look for your home in 
          <linkto text="Denver" to="/location/denver"></linkto>,
          <linkto text="Colorado Springs" to="/location/coloradosprings"></linkto> 
          or <linkto text="Pueblo" to="/location/pueblo"></linkto>, give AquaDuct a call at 
           <phonenumber phone="(719) 390-7663"></phonenumber> for
          a FREE estimate. We’ll discuss your options and help you make your
          vision for your home’s exterior come true!
        </p>
      </v-col>
      <v-col cols="12" xl="4" lg="4" md="4" sm="12">
        <estimate></estimate>
        <!-- <guild></guild> -->
      </v-col>
    </v-row>
    <v-row>
        <v-col col="12" xl="4" lg="4" md="4" sm="12">
            <v-img :src="image2" class="image" alt="Siding Image" left></v-img>
        </v-col>
        <v-col col="12" xl="4" lg="4" md="4" sm="12">
            <v-img :src="image3" class="image" alt="Siding Image" left></v-img>
        </v-col>
        <v-col col="12" xl="4" lg="4" md="4" sm="12">
            <v-img :src="image4" class="image" alt="Siding Image" left></v-img>
        </v-col>
    </v-row>
  </v-container>
</template>

<script>
import estimate from "../../components/controls/estimate-ctrl";
// import router from '@/_router/index'
// import guild from "@/components/controls/GuildQuality";
import linkto from "@/components/controls/link-to";
import phonenumber from "@/components/controls/phone-number";

export default {
  name: "siding-home",

  components: {
    estimate,
    // guild,
    linkto,
    phonenumber
  },

  created() {},

  computed: {
    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },
  },

  data: () => ({
    image: require("@/assets/siding-1.jpg"),
    image2: require("@/assets/siding-2.jpg"),
    image3: require("@/assets/siding-3.jpg"),
    image4: require("@/assets/siding-4.jpg"),
  }),

  methods: {},
};
</script>

<style lang="scss" scoped>

.image {
  margin-bottom: 20px;
}
</style>
